export enum RatingValue {
  No_Experience = 1,
  Intermittent_Experience,
  Proficient,
  Expert_Level,
}
